window.crChat = (function() {

	/**
	 * Show the chat widget minimized and turn on the sound
	 */
	var show = function() {
		$zopim.livechat.window.hide(); // show the chat but keep it minimized
		$zopim.livechat.setDisableSound(false);
	};

	/**
	 * Show the chat widget maximized and turn on the sound
	 */
	var showAndMaximize = function() {
		$zopim.livechat.window.show(); // show the chat but keep it minimized
		$zopim.livechat.setDisableSound(false);
	};

	/**
	 * Hide the chat widget and turn off the sound
	 */
	var hide = function() {
		$zopim.livechat.hideAll();
		$zopim.livechat.setDisableSound(true);
	};



	return {

		init: function() {
			var self = this;
			if (typeof $zopim !== "undefined") {
				$zopim(function() {
					// try to show hide asap (prevent the brief chat apparition on desktop)
					self.showHideAndUpdateUser();

					$zopim.livechat.setOnConnected(function() {
						// try to show hide after connection (needed if the first call was too fast and so ignored)
						self.showHideAndUpdateUser(true);
					});

					// hide the chat widget  when the user ends the chat
					$zopim.livechat.setOnChatEnd(function() {
						hide();
					});
				});
			}
		},

		showHideAndUpdateUser: function(updateUser) {
			var self = this;
			var userInfos = crUser.getInfos();
			// chat in progress
			var isChatting = $zopim.livechat.isChatting();
			var chattable = userInfos.chattable;

			if (isChatting || chattable) {
				// set user infos
				if (updateUser) {
					self.updateWithUserInfos(userInfos);
				}
				var isMaximized = $zopim.livechat.window.getDisplay();
				if (!isMobile && isMaximized) {
					// display the chat
					showAndMaximize();
				} else {
					// display the chat minimized
					show();
				}
			} else {
				// hide the chat
				hide();
			}
		},


		/**
		 * Update the user infos in the zendesk chat with the data from CR
		 * @param  {Object} userInfos data containing the user informations (name, email, phone)
		 */
		updateWithUserInfos: function(userInfos) {
			if (typeof $zopim !== "undefined" && userInfos && userInfos.usrId) {
				var visitorName = $zopim.livechat.getName();
				if (!visitorName || visitorName.indexOf('Visitor') > -1) {
					// set name and email
					var data = {};
					var name;
					if (userInfos.name) {
						name = userInfos.name;
					} else if (userInfos.firstName) {
						name = (userInfos.firstName + ' ' + userInfos.lastName).trim();
					}
					data.name = name || '';
					data.email = userInfos.email || '';
					data.phone = userInfos.phone || '';
					$zopim.livechat.set(data);

					// add notes
					if (userInfos.usrId) {
						var userNotes = 'UID : ' + userInfos.usrId;
						$zopim.livechat.appendNotes(userNotes);
					}
					if (userInfos.csr && userInfos.csr.firstName) {
						var agentNotes = 'CSR : ' + userInfos.csr.firstName;
						$zopim.livechat.appendNotes(agentNotes);
					}
				}
			}
		}
	};
})();
